import WatchAppHelpZoneScreen from '../../../app/src/screens/WatchAppHelp/ZoneScreen.js';
import WatchAppHelpNavigationScreen from '../../../app/src/screens/WatchAppHelp/NavigationScreen.js';
import WatchAppHelpTemperatureScreen from '../../../app/src/screens/WatchAppHelp/TemperatureScreen.js';
import WatchAppHelpModesScreen from '../../../app/src/screens/WatchAppHelp/ModesScreen.js';
import WatchAppHelpPlusHoursScreen from '../../../app/src/screens/WatchAppHelp/PlusHoursScreen.js';
import {
  AutoModeIcon,
  MapIcon,
  PlusHoursIcon,
  ThermometerIcon,
  ThermostatIcon,
} from '../components/icons.jsx';

// The Watch App help topics, in the app's order (screens/WatchAppHelp/List.js).
// Each page is the app's own topic screen, rendered in place: its copy, its step
// structure and its illustrations are the app's, laid out by the web's Topic and
// Steps (see plugins/appShims.js). Only the list itself is restated here — the
// app's list is React Navigation screen names and native list rows — so the five
// titles and their icons are the one thing to keep in step with the app's List.
export const watchTopics = [
  {
    slug: 'zone',
    title: 'Zone screen',
    icon: <ThermostatIcon />,
    Screen: WatchAppHelpZoneScreen,
  },
  {
    slug: 'navigation',
    title: 'Navigation',
    icon: <MapIcon />,
    Screen: WatchAppHelpNavigationScreen,
  },
  {
    slug: 'temperature',
    title: 'Changing temperature',
    icon: <ThermometerIcon />,
    Screen: WatchAppHelpTemperatureScreen,
  },
  {
    slug: 'modes',
    title: 'Changing modes',
    icon: <AutoModeIcon />,
    Screen: WatchAppHelpModesScreen,
  },
  {
    slug: 'plus-hours',
    title: 'Setting Plus Hours',
    icon: <PlusHoursIcon />,
    Screen: WatchAppHelpPlusHoursScreen,
  },
];

export function findWatchTopic(slug) {
  return watchTopics.find((topic) => topic.slug === slug) ?? null;
}
